// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectedOption_root__27cgN","filter":"SelectedOption_filter__1EigI","dateFilter":"SelectedOption_dateFilter__syjqg","icon":"SelectedOption_icon__3fsU6"};